import bannerImg from './banners/woman-helping-man-gym.jpg';

export default {
    id: 'anamnese-fitness-completa',
    title: 'Anamnese fitness completa',
    description: 'Anamnese detalhada com histórico médico, estilo de vida e objetivos para programas de treino online.',
    indicatedFor: 'Personal trainers',
    stepsCount: 3,
    questionsSummary: ['Histórico médico', 'Estilo de vida', 'Objetivos', 'Composição corporal'],
    banner: `url(${bannerImg}) center / cover no-repeat`,
    formData: {
        title: 'Anamnese fitness completa',
        active: false,
        allow_multiple_answers: false,
        theme: 'light',
        steps: [
            {
                order: 1,
                title: 'Dados pessoais',
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: 'Continuar',
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'full_name',
                        label: 'Nome completo',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'gender',
                        label: 'Gênero',
                        description: null,
                        required: false,
                        settings: null,
                    },
                    {
                        order: 3,
                        type: 'body_structure',
                        label: 'Estrutura corporal',
                        description: null,
                        required: false,
                        settings: null,
                    },
                    {
                        order: 4,
                        type: 'weight',
                        label: 'Peso atual',
                        description: null,
                        required: true,
                        settings: null,
                    },
                ],
            },
            {
                order: 2,
                title: 'Histórico de saúde',
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: 'Continuar',
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'yes_no_maybe',
                        label: 'Você possui alguma doença crônica (hipertensão, diabetes, etc.)?',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'yes_no_maybe',
                        label: 'Você faz uso de algum medicamento de uso contínuo?',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 3,
                        type: 'text',
                        label: 'Possui alguma lesão, dor ou limitação física? Descreva.',
                        description: null,
                        required: false,
                        settings: null,
                    },
                ],
            },
            {
                order: 3,
                title: 'Objetivos e estilo de vida',
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: 'Enviar',
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'choices',
                        label: 'Qual é o seu principal objetivo?',
                        description: null,
                        required: true,
                        settings: {
                            options: [
                                { id: 'opt-1', label: 'Emagrecer' },
                                { id: 'opt-2', label: 'Ganhar massa muscular' },
                                { id: 'opt-3', label: 'Melhorar o condicionamento' },
                                { id: 'opt-4', label: 'Saúde e bem-estar' },
                            ],
                        },
                    },
                    {
                        order: 2,
                        type: 'choices',
                        label: 'Qual é a sua rotina de sono?',
                        description: null,
                        required: true,
                        settings: {
                            options: [
                                { id: 'opt-1', label: 'Menos de 6 horas' },
                                { id: 'opt-2', label: '6–7 horas' },
                                { id: 'opt-3', label: '7–8 horas' },
                                { id: 'opt-4', label: 'Mais de 8 horas' },
                            ],
                        },
                    },
                    {
                        order: 3,
                        type: 'scale',
                        label: 'Como você avalia seu nível de estresse diário?',
                        description: null,
                        required: true,
                        settings: {
                            min: 1,
                            max: 5,
                            minLabel: 'Baixo',
                            maxLabel: 'Muito alto',
                            dotConfigs: [
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                            ],
                        },
                    },
                ],
            },
        ],
        actions: [],
    },
};
